export default (el, boolShowEl) => {
	if (boolShowEl) {
		el.removeAttribute('hidden');
	} else {
		el.setAttribute('hidden', true);
	}
};
